import { render, staticRenderFns } from "./video-modal.vue?vue&type=template&id=1c6bff8e&scoped=true"
import script from "./video-modal.vue?vue&type=script&lang=js"
export * from "./video-modal.vue?vue&type=script&lang=js"
import style0 from "./video-modal.vue?vue&type=style&index=0&id=1c6bff8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6bff8e",
  null
  
)

export default component.exports